<h1>How to screenshot a webpage using Microsoft Edge</h1>
<p>
    The Microsoft Edge browser has a convenient screenshot function built-in that may be useful to snapshot dashboards
    and status reports for use in other reports.
</p>
<ul>
    <li>Click the 3 ellipses (…) in the top right corner.</li>
    <li>Select “Screenshot” option.</li>
    <li>use one of the two options to capture an area or the full page. If you chose to "capture area", you can scroll
        and capture more than what is currently displayed on your screen.</li>
</ul>
<img ngSrc="assets/screenshot.png" width="400" height="400" alt="how to screenshot in EDGE" />
<button mat-raised-button color="primary" (click)="soModalService.close();"
    style="position: absolute; right:100px; bottom: 100px;">Close</button>